import './_product-slogan.scss';

export default () => {};
